import { useCallback } from "react";
import { getLowerCaseString } from "helpers/function";

export const useSearch = (component) => {
  const filterBySearchValue = useCallback(
    (value) => {
      const searchValue = getLowerCaseString(value);
      let filteredComponent = [...component];

      filteredComponent = filteredComponent.filter((el) => {
        const titleValue = el.params?.["fr"]?.title?.value || "";
        return getLowerCaseString(titleValue).indexOf(searchValue) >= 0;
      });

      return filteredComponent;
    },
    [component]
  );

  const searchElement = useCallback(
    (searchValue) => {
      if (searchValue && searchValue.trim()) {
        return filterBySearchValue(searchValue);
      } else {
        return component;
      }
    },
    [component, filterBySearchValue]
  );

  return {
    searchElement,
    filterBySearchValue,
  };
};
